// extracted by mini-css-extract-plugin
module.exports = {"animated":"e_7z","dots":"e_8z"};